export default "__VITE_ASSET__BBGpjbEP__"